import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initAnalytics, initEventTracking } from "@/lib/analytics";

// Initialize GA4 (production only, consent-gated) before the app renders.
initAnalytics();
initEventTracking();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
